module.exports = __webpack_public_path__ + "static/img/about-d.4ca8f60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-d.jpg
// module id = Inzz
// module chunks = 1